import axios from "axios";


export const getRejectedReasons = async () => {
    //console.log("getRejectedReasons");
    const response = await axios.get("api/rejectedreasons");
    const result = response.data;
    return result;
}
